import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import NotificationStore from '../../store/NotificationStore';


const ANIMATION_TIME = 2000;


function PromoCodeSection(props) {
  const {
    listOfActiveCampaigns,
    fetchPackages,
    setPromoCodeInfo,
    showPromoInput,
    isFanzoneSubscriptionPage,
    anchorShortUrl,
    setAnimationState,
    hasPromoInUrl,
  } = props;
  const [promoCodeInput, setPromoCodeInput] = useState('');
  const [animationTimeoutId, setAnimationTimeoutId] = useState(null);
  const [shouldShowPromoInputField, setShouldShowPromoInputField] = useState(false);

  useEffect(() => {
    if (hasPromoInUrl?.affiliateCode) {
      setPromoCodeInput(hasPromoInUrl?.affiliateCode);
      checkForDiscountedProduct();
    }
  }, [checkForDiscountedProduct, hasPromoInUrl]);

  const onPromoInputChange = useCallback((e) => {
    const { value } = e.target;
    setPromoCodeInput(value.toUpperCase());
  }, []);

  const findPromoWithNameAndCode = useCallback((anchorName) => {
    const activeCampaigns = listOfActiveCampaigns.find((campaign) => {
      const hasAnchorName = campaign.name.toLowerCase().includes(anchorName);
      const hasPromoCode = campaign.affiliateCode === promoCodeInput;

      return hasAnchorName && hasPromoCode;
    });

    return activeCampaigns;
  }, [listOfActiveCampaigns, promoCodeInput]);

  const findIfPromoIsValid = useCallback(() => {
    if (isFanzoneSubscriptionPage) {
      const FANZONE_CAMPAIGN = listOfActiveCampaigns.find((campaign) => campaign.affiliateCode === 'ASN23FANZONE');
      if (promoCodeInput === 'ASN23FANZONE' && FANZONE_CAMPAIGN) {
        return FANZONE_CAMPAIGN;
      }

      if (anchorShortUrl === 'live') {
        return findPromoWithNameAndCode('live');
      }

      const patternToMatch = /naked-news-anchor-([^-]*)/;
      const anchorFirstName = patternToMatch.exec(anchorShortUrl)?.[1];

      return findPromoWithNameAndCode(anchorFirstName);
    }

    return listOfActiveCampaigns.find(({ affiliateCode }) => affiliateCode === promoCodeInput);
  }, [isFanzoneSubscriptionPage, listOfActiveCampaigns, anchorShortUrl, findPromoWithNameAndCode, promoCodeInput]);

  const handleAnimationState = useCallback(() => {
    const animationTimeout = setTimeout(() => {
      setAnimationState(false);
    }, ANIMATION_TIME);
    setAnimationTimeoutId(animationTimeout);
  }, [setAnimationState]);

  const checkForDiscountedProduct = useCallback((e) => {
    e.preventDefault();
    const activePromotion = findIfPromoIsValid();
    if (activePromotion) {
      fetchPackages(activePromotion.affiliateCode);
      setPromoCodeInfo(activePromotion.affiliateCode);
    } else {
      NotificationStore.error(`${promoCodeInput} is not a valid promo code!`);
    }
    handleAnimationState();
  }, [fetchPackages, findIfPromoIsValid, handleAnimationState, promoCodeInput, setPromoCodeInfo]);

  const togglePromoInput = useCallback((e) => {
    e.preventDefault();
    setShouldShowPromoInputField(!shouldShowPromoInputField);
  }, [shouldShowPromoInputField]);

  const handleKeyPress = useCallback((e) => {
    if (e?.key === 'Enter') {
      checkForDiscountedProduct(e);
    }
  }, [checkForDiscountedProduct]);

  useEffect(() => () => {
    clearTimeout(animationTimeoutId);
  }, [animationTimeoutId]);

  if (!showPromoInput) {
    return null;
  }

  return (
    <div
      className={
        classnames({
          'hide-promo-input': !shouldShowPromoInputField,
          'show-promo-input': shouldShowPromoInputField,
        })
      }
    >
      <h6 className="promo-closed">
        Have a promo code?
        <button onClick={togglePromoInput}>Click Here</button>
      </h6>
      <div
        className="promo-input promo-open"
      >
        <input
          className="promo-text-input"
          placeholder="PROMO CODE"
          type="text"
          value={promoCodeInput}
          onChange={onPromoInputChange}
          onKeyPress={handleKeyPress}
        />
        <button
          className="col-md-2 promo-apply-btn"
          onClick={checkForDiscountedProduct}
        >
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  );
}

export default PromoCodeSection;

PromoCodeSection.propTypes = {
  fetchPackages: PropTypes.func.isRequired,
  isFanzoneSubscriptionPage: PropTypes.bool.isRequired,
  listOfActiveCampaigns: PropTypes.array.isRequired,
  setPromoCodeInfo: PropTypes.func.isRequired,
  showPromoInput: PropTypes.bool.isRequired,
};
